<template>
<div class="workbench">
    <div class="container more-project" v-if="moreVisible">
        <div class="container-top">
            <el-button icon="el-icon-back" @click="backWork" size="mini"></el-button>
            <div style="line-height: 32px">我的项目</div>
        </div>
        <project-list style="height: calc(100% - 60px)"></project-list>
    </div>
    <div class="container" v-else>
        <div class="container-top">
            <span class="title">我的项目</span>
            <span class="link" @click="jumpMyProject">
                更多<i class="el-icon-d-arrow-right"></i>
            </span>
        </div>
        <div class="container-detail">
            <div class="left">
                <LatelyFile/>
            </div>
            <div class="right">
                <MyProject/>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import projectList from "./projectList.vue"
import LatelyFile from "./latelyFile.vue";
import myProject from "./myProject.vue";
import MyProject from "./myProject.vue";
export default {
    components: { projectList, LatelyFile, myProject, MyProject },
    data() {
        return {
            moreVisible: false
        }
    },
    methods: {
        jumpMyProject() {
            this.moreVisible = true
        },
        backWork() {
            this.moreVisible = false
        }
    }
}
</script>

<style scoped lang="scss">
.workbench {
    height: 100%;
    width: 100%;
    padding: 12px;
    box-sizing: border-box;
    .more-project.container {
        background-color: #fff;
        .container-top {
            &::before {
                display: none;
            }
        }
    }
    .container {
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
        &-top {
            display: flex;
            align-items: center;
            gap: 5px;
            padding: 15px 15px;
            flex-shrink: 0;
            line-height: 20px;
            background-color: #fff;
            span.title {
                font-size: 16px;
                font-weight: bold;
            }
            span.link {
                color: #aaa;
                user-select: none;
                cursor: pointer;
                margin-left: auto;
            }
            border-radius: 7px;
            position: relative;
            &::before {
                content: '';
                background-color: #5584ff;
                width: 3px;
                height: 16px;
                border-radius: 8px;
            }
        }
        & > :not(.container-top) {
            flex-grow: 1;
            min-height: 0px;
        }
        &-detail {
            display: flex;
            align-items: center;
            gap: 10px;
            flex-grow: 1;
            min-height: 0px;

            .left {
                height: 100%;
                @media screen and (max-width: 1100px) {
                    width: 200px;
                }
                @media screen and (min-width: 1097px) {
                    width: 250px;
                }
                @media screen and (min-width: 1280px) {
                    width: 280px;
                }
                @media screen and (min-width: 1536px) {
                    width: 300px;
                }
                @media screen and (min-width: 1745px) {
                    width: 350px;
                }
                @media screen and (min-width: 1930px) {
                    width: 420px;
                }
            }
            .right {
                flex-grow: 1;
                height: 100%;
                min-width: 0px;
                overflow: hidden auto;
            }
        }
    }
}
</style>